import React, { useEffect, useState } from "react";
import { isFirefox, isSafari } from "react-device-detect";
import {
  getNativeDeviceCapabilities,
  isNativeMobileShell,
} from "../native/mobileBridge";

function WarningBanner() {
  const [messages, setMessages] = useState([]);
  const [dismissed, setDismissed] = useState(false);
  const nativeShell = isNativeMobileShell();

  useEffect(() => {
    const warnings = [];

    // 🔧 Manual override
    const forceLowMem = localStorage.getItem("lowmem") === "true";

    // The Android shell exposes real device data; browsers only provide a
    // coarse memory estimate on platforms that support navigator.deviceMemory.
    const nativeCapabilities = getNativeDeviceCapabilities();
    const memory = nativeCapabilities?.memoryGb ?? navigator.deviceMemory;






    // These are deliberately forgiving minimums. This warning is intended for
    // genuinely constrained/older hardware, not every phone below flagship tier.
    const belowNativeRecommendation = nativeCapabilities && (
      nativeCapabilities.lowRamDevice === true ||
      nativeCapabilities.memoryGb < 4 ||
      nativeCapabilities.cpuCores < 6 ||
      nativeCapabilities.androidSdk < 29 ||
      (nativeCapabilities.openGlEsVersion > 0 &&
        nativeCapabilities.openGlEsVersion < 0x00030001)
    );

    if (forceLowMem || belowNativeRecommendation || (!nativeCapabilities && memory && memory <= 4)) {
      warnings.push(
        "Your device is below the recommended minimum system specs. You may experience issues loading or running your virtual therapy space."
      );
    }

    // 🌐 Browser compatibility
    if (!isNativeMobileShell() && (isFirefox || isSafari)) {
      warnings.push(
        "Not all Plutonic features are currently supported in Firefox or Safari. For the best experience, please use Chrome or Edge."
      );
    }

    setMessages(warnings);
  }, []);

  if (messages.length === 0 || dismissed) return null;

  return (
    <div
      className={`warning-banner${nativeShell ? " warning-banner--mobile" : ""}`}
      role="status"
    >
      <div className="warning-banner__icon" aria-hidden="true">⚠️</div>
      <div className="warning-banner__content">
        {nativeShell && <strong>Performance notice</strong>}
        {messages.map((msg, index) => (
          <div key={index}>{msg}</div>
        ))}
      </div>
      <button
        type="button"
        className="warning-banner__dismiss"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss performance notice"
      >
        ×
      </button>
    </div>
  );
}

export default WarningBanner;
